<template>
    <PageBaseLayout>
        <template #main>
            <div class="backlight"></div>
            <div class="container">
                <div class="header rounded">
                </div>
                
                <div class="text-left">
                    <br>
                    <h6>Become a Contributor</h6>
                    <br>
                    <p>Complete our onboarding journey in this Telegram bot and share your thoughts on what the concrete values for the following constants should be.</p>                
                    <br><br>
                </div>

                <div class="box rounded">
                    <div class="box-inner">
                        <img class="icon" src="data:image/svg+xml;base64,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">
                        <p>By doing so you'll have the chance to get your wallet address whitelisted for Contributors’ Rounds</p>                        
                    </div>
                </div>
            </div>
        </template>

        <template #bottom>
            <div class="bottom">
                <BaseButton page-id="MorePerks01">What are Contributors’ Rounds? &nbsp;<i class="icon next"></i></BaseButton>
            </div>
        </template>
    </PageBaseLayout>
</template>

<style lang="scss" scoped>
@use '@/assets/css/_tools' as *;
@use '@/assets/css/_shared' as *;

.container {
    padding: 30px;
}

.backlight {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYyIiBoZWlnaHQ9IjMwMyIgdmlld0JveD0iMCAwIDM2MiAzMDMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2ZfMTJfMjAzKSI+CjxwYXRoIGQ9Ik00MDAuMTggLTExMS4wNDhDMzYzLjM3NiAtMTQ2LjM2OCAyNTEuMjY1IC04OS4yNjc3IDE0OS43NzEgMTYuNDg4OUM0OC4yNzc1IDEyMi4yNDYgLTQuMTY0MzIgMjM2LjYxMSAzMi42MzkgMjcxLjkzQzY5LjQ0MjMgMzA3LjI1IDE4MS41NTQgMjUwLjE1IDI4My4wNDggMTQ0LjM5M0MzODQuNTQxIDM4LjYzNjUgNDM2Ljk4MyAtNzUuNzI4NiA0MDAuMTggLTExMS4wNDhaIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWxfMTJfMjAzKSIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2ZfMTJfMjAzIiB4PSIwLjg3NjcwOSIgeT0iLTE0MS41IiB3aWR0aD0iNDMxLjA2NSIgaGVpZ2h0PSI0NDMuODgzIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjEwIiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfMTJfMjAzIi8+CjwvZmlsdGVyPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfMTJfMjAzIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDQwNy45ODkgLTEwMy41NTQpIHJvdGF0ZSgxMzUuMzg5KSBzY2FsZSgzOTUuNzc2IDEzNy42NDkpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzA1MDkxMCIgc3RvcC1vcGFjaXR5PSIwIi8+CjxzdG9wIG9mZnNldD0iMC40NTQiIHN0b3AtY29sb3I9IiMwNzExMjAiLz4KPHN0b3Agb2Zmc2V0PSIwLjc2NCIgc3RvcC1jb2xvcj0iIzA5MEUxNiIgc3RvcC1vcGFjaXR5PSIwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==");
    background-position: top center;
}

.header {
    position: relative;
    height: 242px;
    
    
    background-color: var(--color-bg);
    background-repeat: no-repeat;
    background-size: 162px;
    background-position: center;

    @include responsive-bg-x4('@/assets/imgs/contrib/contrib.png');

    &::before {
        content: '';
        position: absolute;
        inset: -2px;
        border-radius: $rounded-radius;

        background-image: linear-gradient(0deg, #1C2430, #1C2430),
                            linear-gradient(53.85deg, rgba(5, 9, 16, 0.8) 43.83%, rgba(5, 9, 16, 0) 74%),
                            linear-gradient(183.34deg, #4F6180 -8.17%, rgba(79, 97, 128, 0) 7.94%);
        background-blend-mode: color;

        z-index: -1;
    }
}

.box {
    margin-top: 20px;
    padding: 2px;
    background-image: conic-gradient(from 180deg, #000E8B 0%, #000E8B 19%, #972199 25%, #000E8B 28%, #3C60FE 45%, transparent 45%, transparent 55%, #3C60FE 55%, #000E8B 68%, #972199 73%, #000E8B 81%, #000E8B 100%);
}

.box-inner {
    position: relative;
    padding: 40px 16px 40px 16px;
    border-radius: $rounded-radius;
    background-color: var(--color-bg);

    .icon {
        position: absolute;
        top: 0;
        left: 50%;
        translate: -50% -50%;
    }
}

</style>